export const focusableWebComponents =
  'ds-accordion-item, ds-checkbox, ds-input';
export const focusableElements =
  'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), iframe';

export function firstFocusableElement(container) {
  const firstFocusableWebComponent = container.querySelectorAll(
    focusableWebComponents
  )[0];
  let firstFocusableElement;

  if (firstFocusableWebComponent) {
    firstFocusableElement =
      firstFocusableWebComponent.shadowRoot.querySelectorAll(
        focusableElements
      )[0];
  } else {
    firstFocusableElement = container.querySelectorAll(focusableElements)[0];
  }

  return firstFocusableElement;
}

export function lastFocusableElement(container) {
  const focusableContent = container.querySelectorAll(focusableElements);
  const lastFocusableElement = focusableContent[focusableContent.length - 1];

  return lastFocusableElement;
}

export function trapFocus(container, e) {
  let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

  if (!isTabPressed) {
    return;
  }

  if (e.shiftKey) {
    if (
      e.target === container.querySelectorAll('h2')[0] ||
      e.target === firstFocusableElement(container)
    ) {
      lastFocusableElement(container).focus();
      e.preventDefault();
    }
  } else {
    if (e.target === lastFocusableElement(container)) {
      firstFocusableElement(container).focus();
      e.preventDefault();
    }
  }

  return;
}
